<template>
  <div id="resetpwd">
    <div class="top">
      <i class="iconfont icon-zhaohuimima"></i>
    </div>
    <div class="form">
      <input type="password" class="" placeholder="请输入旧密码" v-model="password">
      <input type="password" class="" placeholder="请输入新密码" v-model="password1">
      <input type="password" class="" placeholder="再次输入新密码" v-model="password2">
      <button style="margin-top: -5px" @click="submit()">重置</button>
      <p>放弃重置，<span><router-link class="first" :to="{name: 'zcgl', params: {nr: 'index'}}">返回</router-link></span></p>
    </div>
    <alert :showModal.sync="showAlert">{{alertMessage}}</alert>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  import alert from '@/components/alert/alert'
  import md5 from 'js-md5'
  import router from '@/router'

  export default {
    name: 'resetpwd',
    data () {
      return {
        password: '',
        password1: '',
        password2: '',
        alertMessage: '',
        showAlert: false
      }
    },
    components: {alert},
    methods: {
      submit: function () {
        if (!this.password) {
          this.alertMessage = '原始密码为空'
          this.showAlert = true
          return
        }
        if (!this.password1) {
          this.alertMessage = '新密码为空'
          this.showAlert = true
          return
        }
        if (this.password1 !== this.password2) {
          this.alertMessage = '两次密码不同'
          this.showAlert = true
          return
        }
        let senddata = {
          password: md5(this.password),
          password1: md5(this.password1)
        }
        ajax.resetpwd(senddata).then(
          () => {
            this.alertMessage = '重置成功'
            this.showAlert = true
            this.$watch('showAlert', function () {
              router.push({name: 'zcgl', params: {nr: 'index'}})
            })
          })
      }
    },
    created: function () {
      this.$emit('update:titlestr', '密码重置')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// resetpwd.vue?da796546